import { render, staticRenderFns } from "./demanYaoqing.vue?vue&type=template&id=08375532&scoped=true"
import script from "./demanYaoqing.vue?vue&type=script&lang=js"
export * from "./demanYaoqing.vue?vue&type=script&lang=js"
import style0 from "./demanYaoqing.vue?vue&type=style&index=0&id=08375532&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08375532",
  null
  
)

export default component.exports